'use strict';

angular.module('TurneroApp').component('coGrupoUsuariosModificar', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '=',
    },
    controller: [
        'grupoUsuarioService',
        'utilsService',
        'TurneroAppConstant',
        function (grupoUsuarioService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.grupoEditar = {};
            ctrl.usuariosModificar = [];

            ctrl.errores = {
                Usuarios: false,
                N_Grupo_Usuario: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadModificar = function (item) {
                    ctrl.errores = {
                        Usuarios: false,
                        N_Grupo_Usuario: false,
                    };

                    if (item && item.Id_Grupo_Usuario && ctrl.centroAtencionSeleccionado.id) {
                        grupoUsuarioService.getInfo({
                            'id_Grupo_Usuario': item.Id_Grupo_Usuario,
                            'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                        }).$promise.then(function (data) {
                            ctrl.grupoEditar = data
                            ctrl.obtenerUsuarioshabilitados(data)
                        }).catch(function (error) {
                            utilsService.errores(error);
                        });
                    }
                }
            }

            ctrl.cambiosEnUsuariosEdit = function (item) {
                ctrl.grupoEditar.usuariosModificar = item;
            };

            ctrl.obtenerUsuarioshabilitados = function () {
                ctrl.usuariosModificar = [];
                var Usuarios = [];
                for (var i = 0; i < ctrl.grupoEditar.UsuariosAsignados.length; i++) {
                    ctrl.usuariosModificar.push({
                        'id': ctrl.grupoEditar.UsuariosAsignados[i].Id_Centro_Usuario.toString(),
                        'text': ctrl.grupoEditar.UsuariosAsignados[i].N_Usuario
                    });
                    Usuarios.push({
                        'id': ctrl.grupoEditar.UsuariosAsignados[i].Id_Centro_Usuario.toString(),
                        'text': ctrl.grupoEditar.UsuariosAsignados[i].N_Usuario
                    })
                }
                for (var i = 0; i < ctrl.grupoEditar.Usuarios.length; i++) {
                    Usuarios.push({
                        'id': ctrl.grupoEditar.Usuarios[i].id,
                        'text': ctrl.grupoEditar.Usuarios[i].text
                    })

                }
                ctrl.grupoEditar.Usuarios = Usuarios;
            };

            ctrl.asignarAltasyBajas = function () {
                //limpio las listas, para que no quede basura en la variable del scope.
                ctrl.grupoEditar.Id_Grupo_Usuario_Baja = '';
                ctrl.grupoEditar.Id_Usuario_Alta = '';
                if (ctrl.grupoEditar.UsuariosAsignados.length > 0) {
                    //en la lista de roles Usuarios, busco los que no estan en la lista de usuariosModificar y los agrego para baja.
                    for (var i = 0; i < ctrl.grupoEditar.UsuariosAsignados.length; i++) {
                        if (ctrl.grupoEditar.usuariosModificar != undefined && ctrl.grupoEditar.usuariosModificar != null) {
                            var existe = false;
                            for (var j = 0; j < ctrl.grupoEditar.usuariosModificar.length; j++) {
                                if (ctrl.grupoEditar.usuariosModificar[j].id == ctrl.grupoEditar.UsuariosAsignados[i].Id_Centro_Usuario) {
                                    existe = true;
                                }
                            }
                            if (!existe) {
                                ctrl.grupoEditar.Id_Grupo_Usuario_Baja = ctrl.grupoEditar.Id_Grupo_Usuario_Baja + ctrl.grupoEditar.UsuariosAsignados[i].Id_Centro_Usuario;
                                ctrl.grupoEditar.Id_Grupo_Usuario_Baja = i == ctrl.grupoEditar.length - 1 ? ctrl.grupoEditar.Id_Grupo_Usuario_Baja : ctrl.grupoEditar.Id_Grupo_Usuario_Baja + ',';
                            }
                        }
                    }
                }

                if (ctrl.grupoEditar.usuariosModificar != undefined && ctrl.grupoEditar.usuariosModificar != null && ctrl.grupoEditar.usuariosModificar.length > 0) {
                    //en la lista de roles modificados, busco los que no coinciden con RolesUsuarios y los agrego a la lista de Agregar.
                    for (var i = 0; i < ctrl.grupoEditar.usuariosModificar.length; i++) {
                        var existe = false;

                        for (var j = 0; j < ctrl.grupoEditar.UsuariosAsignados.length; j++) {
                            if (ctrl.grupoEditar.usuariosModificar[i].id == ctrl.grupoEditar.UsuariosAsignados[j].Id_Centro_Usuario) {
                                existe = true;
                            }
                        }
                        if (!existe) {
                            ctrl.grupoEditar.Id_Usuario_Alta = ctrl.grupoEditar.Id_Usuario_Alta + ctrl.grupoEditar.usuariosModificar[i].id;
                            ctrl.grupoEditar.Id_Usuario_Alta = i == ctrl.grupoEditar.usuariosModificar.length - 1 ? ctrl.grupoEditar.Id_Usuario_Alta : ctrl.grupoEditar.Id_Usuario_Alta + ',';
                        }
                    }
                }
                ctrl.grupoEditar.Id_Grupo_Usuario_Baja = ctrl.grupoEditar.Id_Grupo_Usuario_Baja.charAt(ctrl.grupoEditar.Id_Grupo_Usuario_Baja.length - 1) == ',' ? ctrl.grupoEditar.Id_Grupo_Usuario_Baja.slice(0, -1) : ctrl.grupoEditar.Id_Grupo_Usuario_Baja;
                ctrl.grupoEditar.Id_Usuario_Alta = ctrl.grupoEditar.Id_Usuario_Alta.charAt(ctrl.grupoEditar.Id_Usuario_Alta.length - 1) == ',' ? ctrl.grupoEditar.Id_Usuario_Alta.slice(0, -1) : ctrl.grupoEditar.Id_Usuario_Alta;
            };

            ctrl.guardarGrupoEditado = function () {
                ctrl.grupoEditar.Id_Centro_Atencion = ctrl.centroAtencionSeleccionado.id;
                ctrl.asignarAltasyBajas();

                ctrl.errores.N_Grupo_Usuario = !(ctrl.grupoEditar.N_Grupo_Usuario);
                ctrl.errores.Usuarios = !(ctrl.grupoEditar.usuariosModificar == undefined || ctrl.grupoEditar.usuariosModificar.length > 0)
                if (ctrl.errores.N_Grupo_Usuario || ctrl.errores.Usuarios) {
                    return;
                }

                grupoUsuarioService.update(ctrl.grupoEditar).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Modificar Grupo", "El grupo se modificó correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./grupoUsuariosModificar.html')
});


// WEBPACK FOOTER //
// ./app/components/grupos/grupos-usuarios/grupoUsuariosModificarComponent.js